module.exports = __webpack_public_path__ + "img/proyecto_10.bef172dc.webp";